import { render, staticRenderFns } from "./addExtraResource.vue?vue&type=template&id=0659087e&scoped=true&"
import script from "./addExtraResource.vue?vue&type=script&lang=js&"
export * from "./addExtraResource.vue?vue&type=script&lang=js&"
import style0 from "./addExtraResource.vue?vue&type=style&index=0&id=0659087e&lang=less&scoped=true&"
import style1 from "./addExtraResource.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0659087e",
  null
  
)

component.options.__file = "addExtraResource.vue"
export default component.exports